interface Question {
  question: string;
  answers: string[];  // exactly 4; order determines display order
  correctIndex: number;
}

let questions: Question[] = [];

export async function loadQuestions(): Promise<void> {
  try {
    const res = await fetch('questions.json');
    questions = await res.json() as Question[];
  } catch {
    console.warn('quiz: could not load questions.json — quiz will auto-pass');
  }
}

export function runQuiz(
  quizArea: HTMLElement,
  controls: HTMLElement,
  statusBar: HTMLElement,
): Promise<'correct' | 'wrong'> {
  if (questions.length === 0) return Promise.resolve('correct');

  const q = questions[Math.floor(Math.random() * questions.length)]!;

  return new Promise(resolve => {
    controls.style.display = 'none';
    statusBar.style.display = 'none';
    quizArea.style.display = 'flex';

    (document.getElementById('quiz-question') as HTMLElement).textContent = q.question;
    const answersEl = document.getElementById('quiz-answers') as HTMLElement;
    answersEl.innerHTML = '';

    const indices = q.answers.map((_, i) => i).sort(() => Math.random() - 0.5);
    indices.forEach(i => {
      const btn = document.createElement('button');
      btn.className = 'quiz-answer';
      btn.textContent = q.answers[i]!;
      btn.onclick = () => {
        quizArea.style.display = 'none';
        controls.style.display = '';
        statusBar.style.display = '';
        resolve(i === q.correctIndex ? 'correct' : 'wrong');
      };
      answersEl.appendChild(btn);
    });
  });
}
